// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import LoadingMessage from '../loading-message';
import JobDescription from '../job-description';
import ReferralInfo from '../referral-info';
import { getCustomerLogoPath } from '../../util/customer';
import { ApiClient } from '../../api/apply-page-api-client';
import { withApplyContext } from '../../with-apply-context';

const styles = theme => ({
  container: {
    margin: '0 auto',
    padding: '0 25px',
    width: '100%',
  },
  paper: {
    margin: '20px auto',
    maxWidth: '800px',
  },
  location: {
    padding: '10px 0',
  },
  logo: {
    display: 'block',
    maxWidth: '150px',
    align: 'left',
  },
  logoMobile: {
    display: 'block',
    maxWidth: '150px',
    margin: 'auto',
    marginTop: '40px',
    marginBottom: '15px',
  },
  header: {
    paddingBottom: '20px',
  },
  headline: {
    lineHeight: '1.1em',
    marginBottom: 0,
    align: 'left',
  },
  mobileHeadline: {
    margin: '0px 25px 0px 25px',
    lineHeight: '1.1em',
    marginBottom: 0,
    align: 'left',
  },
});

type Props = CoreApplyProps & {
  classes: Object,
  job: Job,
  org: Org,
}

type State = {
  referral: ?ReferralType,
};

const Header = (props: {
  org: Org,
  job: Job,
  logoPath: string,
  classes: Object,
}) => (
  <Grid container alignItems="center" justify="center" className={props.classes.header}>
    <Hidden xsDown>
      <Grid item xs={6}>
        <a href={props.org.website}><img src={props.logoPath} className={props.classes.logo} alt="Home" /></a>
      </Grid>
      <Grid item xs={6}>
        <div className={props.classes.location}>
          <div>
            <Typography variant="h5" className={props.classes.headline} gutterBottom>{props.job.title}</Typography>
          </div>
          {props.job.city && props.job.state &&
          <div>
            <Typography variant="caption" gutterBottom>{props.job.city}, {props.job.state}</Typography>
          </div>
          }
        </div>
      </Grid>
    </Hidden>
    <Hidden smUp>
      <Grid item xs={12}>
        <a href={props.org.website}><img src={props.logoPath} className={props.classes.logoMobile} alt="Home" /></a>
      </Grid>
    </Hidden>
  </Grid>
);

class ReferralApply extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      referral: null,
    };
  }

  componentDidMount() {
    const { referralHash } = this.props;
    if (!referralHash) {
      throw new Error('No referral hash');
    }
    ApiClient.getReferral(referralHash)
      .then(referral => {
        this.setState({
          referral,
        });
      });
  }

  render() {
    const {
      classes, job, org,
    } = this.props;
    const { referral } = this.state;

    if (!referral) {
      return (
        <LoadingMessage />
      );
    }
    const logoPath = getCustomerLogoPath(org);
    return (
      <React.Fragment>
        <Hidden xsDown>
          <Paper className={classes.paper}>
            <ReferralInfo referral={referral} jobHash={job.job_hash} />
            <div className={classes.container}>
              <Header job={job} org={org} classes={classes} logoPath={logoPath} />
              <JobDescription
                job={job}
                org={org}
              />
            </div>
          </Paper>
        </Hidden>
        <Hidden smUp>
          <ReferralInfo referral={referral} jobHash={job.job_hash} />
          <div className={classes.container}>
            <Header job={job} org={org} classes={classes} logoPath={logoPath} />
            <JobDescription
              job={job}
              org={org}
            />
          </div>
        </Hidden>
      </React.Fragment>
    );
  }
}

/*
DP - 2/22/2019
Used asynchronously in app.jsx
 */
export default withApplyContext(withStyles(styles)(ReferralApply));
